/**
 * PostHog is loaded via GTM (see README), so we never import the SDK here.
 * Call `window.posthog.capture` when the snippet is present; no-op otherwise
 * (local/dev, ad blockers, GTM not fired yet).
 */

export function capturePostHogEvent(eventName, properties = {}) {
  if (typeof window === 'undefined' || !eventName) {
    return;
  }

  const posthog = window.posthog;
  if (!posthog || typeof posthog.capture !== 'function') {
    return;
  }

  try {
    posthog.capture(eventName, properties);
  } catch {
    // Never break the page for analytics.
  }
}
